(function(){
  'use strict';

  function addStyles(){
    if (document.getElementById('erectus-cart-improvements')) return;
    var style = document.createElement('style');
    style.id = 'erectus-cart-improvements';
    style.textContent = [
      '@media (max-width:767px){',
      '.shoppingcart-content{padding-top:10px!important;}',
      '.shoppingcart-content .container.wrap-cart{padding-left:12px!important;padding-right:12px!important;}',
      '.shoppingcart-content .cart-content{margin-bottom:16px!important;}',
      '.shoppingcart-content .cart-item-variant,.shoppingcart-content .cart-item-selling-plan{margin-top:4px!important;font-size:11.5px!important;line-height:1.3!important;opacity:.72!important;}',
      '.shoppingcart-content .free-shipping{margin:14px 0 18px!important;border-radius:10px!important;overflow:hidden!important;}',
      '.shoppingcart-content .free-shipping__text{min-height:44px!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:8px 12px!important;text-align:center!important;font-size:13px!important;line-height:1.3!important;}',
      '.shoppingcart-content .cart-total{margin-top:8px!important;padding:18px 16px!important;border:1px solid rgba(0,0,0,.09)!important;border-radius:12px!important;background:#fff!important;box-shadow:0 6px 20px rgba(0,0,0,.06)!important;}',
      '.shoppingcart-content .cart-total .title{margin:0 0 12px!important;font-size:20px!important;}',
      '.shoppingcart-content .cart-total .info-checkout{padding:7px 0!important;font-size:15px!important;}',
      '.shoppingcart-content .cart-total .info-checkout .total,.shoppingcart-content .cart-total .info-checkout .subtotal{font-weight:700!important;}',
      '.shoppingcart-content .erectus-cart-trust{margin:12px 0 10px!important;padding:10px 12px!important;border-radius:8px!important;background:#f7f7f7!important;font-size:12.5px!important;font-weight:600!important;line-height:1.35!important;text-align:center!important;}',
      '.shoppingcart-content .cart-total .group-button{margin-top:10px!important;}',
      '.shoppingcart-content .cart-total .group-button a[href="/checkout"]{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:54px!important;padding:13px 16px!important;border-radius:8px!important;background:#0d0d0d!important;color:#fff!important;font-size:16px!important;font-weight:700!important;line-height:1.2!important;text-align:center!important;}',
      '.shoppingcart-content .checkout-cart.group-button{margin-top:10px!important;}',
      '.shoppingcart-content .continue-shopping{font-size:13px!important;}',
      '#js_nt_cart_canvas .group-button-checkout a{min-height:46px!important;display:flex!important;align-items:center!important;justify-content:center!important;}',
      '#js_nt_cart_canvas .group-button-checkout a[href="/checkout"]{font-weight:700!important;}',
      '}',
      '@media (max-width:480px){',
      '.shoppingcart-content table.shopping-cart-content{font-size:13px!important;}',
      '.shoppingcart-content .quantity-cart .group-quantity-button{transform:scale(.92);transform-origin:center;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function improveCartPage(){
    var cart = document.querySelector('.shoppingcart-content');
    if (!cart) return;

    var checkout = cart.querySelector('.cart-total .group-button a[href="/checkout"]');
    if (checkout) {
      checkout.textContent = 'Finalizar compra';
      checkout.setAttribute('aria-label', 'Finalizar compra de forma segura');

      var trust = cart.querySelector('.erectus-cart-trust');
      if (!trust) {
        trust = document.createElement('div');
        trust.className = 'erectus-cart-trust';
        trust.setAttribute('role', 'note');
        trust.textContent = 'Pago seguro · Envío discreto · Envío gratis desde $699 MXN';
        checkout.closest('.group-button').insertAdjacentElement('beforebegin', trust);
      }
    }
  }

  function translateLegacyMiniCart(){
    document.querySelectorAll('#js_nt_cart_canvas .title, .minicart-content .title').forEach(function(title){
      if (!/You have|item\(s\) in your cart/i.test(title.textContent || '')) return;
      var countNode = title.querySelector('.count-item');
      var count = countNode ? countNode.textContent.trim() : '0';
      title.textContent = count === '1' ? 'Tienes 1 producto en tu carrito' : 'Tienes ' + count + ' productos en tu carrito';
    });

    document.querySelectorAll('#js_nt_cart_canvas a.remove[title="Remove this item"], .minicart-content a.remove[title="Remove this item"]').forEach(function(link){
      link.setAttribute('title', 'Eliminar producto');
      link.setAttribute('aria-label', 'Eliminar producto');
    });
  }

  function run(){
    addStyles();
    improveCartPage();
    translateLegacyMiniCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('cart:updated', run);
})();
